import { match, P } from 'ts-pattern'

export function isElementVisible(element: HTMLElement | null): boolean {
    if (!element) {
        return false
    }

    const bounding = element.getBoundingClientRect()
    return (
        bounding.top >= 0 &&
        bounding.bottom <=
            (window.innerHeight || document.documentElement.clientHeight)
    )
}

export const entradasSaidas = [
    'ent1',
    'sai1',
    'ent2',
    'sai2',
    'ent3',
    'sai3',
    'ent4',
    'sai4',
    'ent5',
    'sai5',
    'ent6',
    'sai6',
    'ent7',
    'sai7',
    'ent8',
    'sai8',
    'ent9',
    'sai9',
    'ent10',
    'sai10',
    'ent11',
    'sai11',
    'ent12',
    'sai12',
] as const

/** Abaixo do `md` do Tailwind (48rem) a tabela não cabe: a linha vira card. */
export const QUERY_LIST_VIEW = '(max-width: 47.99rem)'

/** Campos em branco que o card oferece além dos registros já lançados. */
const CAMPOS_EM_BRANCO_LIST_VIEW = 2

/**
 * Distribui os campos de entrada/saída do dia em grupos (linhas). Na tabela,
 * a altura da linha cresce em passos de 6 campos; no card do list view, um
 * grupo só com os registros atuais e mais dois em branco.
 */
export function gruposCampos(
    quantidadeRegistros: number,
    isListView: boolean,
): { grupos: number; camposPorGrupo: number } {
    if (isListView)
        return {
            grupos: 1,
            camposPorGrupo: Math.min(
                quantidadeRegistros + CAMPOS_EM_BRANCO_LIST_VIEW,
                entradasSaidas.length,
            ),
        }

    const grupos = match(quantidadeRegistros)
        .with(P.number.between(17, 24), () => 4)
        .with(P.number.between(11, 16), () => 3)
        .with(P.number.between(5, 10), () => 2)
        .otherwise(() => 1)
    return { grupos, camposPorGrupo: 6 }
}
